<script>
import {getCurrentInstance, onMounted, ref, watch, computed} from 'vue';
import commonFn from '@/commons/commonFunction';
import MsCheckbox from '../checkbox/MsCheckbox.vue';

export default {
  components: {MsCheckbox},
  props: {
    title: String,
    width: {
      type: Number,
      default: 400,
    },
    message: [String, Array],
    type: {
      type: Number,
      default: 0,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    textBtn: {
      type: String,
      default: null,
    },
    /**
     * Thêm optionList cho message có dạng chọn
     * tbngoc 22.07.2022
     */
    optionList: {
      type: Array,
      default: null,
    },

    /**
     * Custom text của checkbox
     */
    customLabelCheckbox: {
      type: String,
      default: null,
    },

    /**
     * Custom các button VD: showConfirmValidate(message, title, customButton, width)
     */
    customButton: {
      type: Object,
      default: {Yes: 'Có', No: 'Không', Cancel: 'Hủy'},
    },
    optionDefault: {
      type: Number,
      default: 1,
    },
    /**
     * Hàm custom callback
     */
    customCallback: {
      type: Function,
      default: () => {},
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();

    // Giá trị của checkbox trên form cảnh báo
    const IsShowMessage = ref(true);

    //Biến thể hiện có sự kiện click từ nội dung html truyền vào không
    const isCustomCallBack = ref(false);

    // Option trả về
    const option = ref(1);

    option.value = props.optionDefault;

    onMounted(() => {
      //focus button
      commonFn.focusFirstControl(proxy.$refs['msg']);

      //Add sự kiện vào message truyền vào qua v-html, add class "customCallBack" vào nội dung cần click
      //TVDAT 19/10/2022
      proxy.$nextTick(() => {
        const elements = proxy.$refs['msg'].querySelectorAll('.customCallBack');
        Array.from(elements).forEach(el => {
          el.addEventListener('click', () => {
            isCustomCallBack.value = true;
          });
        });
      });
    });

    function escPress(e, close) {
      e.preventDefault();
      close(this, null);
    }

    /**
     * Check có sự kiện bấm vào message
     * TVDAT 19/10/2022
     */
    watch(isCustomCallBack, newVal => {
      if (newVal) {
        proxy.$close(proxy.$refs['msg'], {isClickCustom: newVal});
      }
    });

    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    return {
      escPress,
      IsShowMessage,
      option,
      dbOptionHeight,
    };
  },
};
</script>

<template>
  <!-- Đợi thiết kế chỉnh lại style sau -->
  <div class="msg-box" @keydown.esc="escPress($event, $close)">
    <div class="msg-center" ref="msg" :style="{width: width + 'px'}">
      <div class="msg-title">{{ title }}</div>
      <div
        v-if="!hideClose"
        class="msg-close icon24 close"
        @click="
          $close(
            this,
            type == this.$ms.constant.MessageBoxType.confirm_Yes_No_Cancel ||
              type == this.$ms.constant.MessageBoxType.confirm_Yes_No_Custom
              ? null
              : false,
          )
        "
      ></div>
      <div
        class="msg-question icon24 ic-question"
        v-if="type == this.$ms.constant.MessageBoxType.confirmIncurredData"
      ></div>
      <div class="msg-message">
        <template v-if="Array.isArray(message)">
          <div class="msg-item" v-for="(item, i) in message" :key="i" v-html="item"></div>
        </template>

        <div
          class="msg-item"
          v-else-if="!Array.isArray(message) && type != this.$ms.constant.MessageBoxType.confirmOnlyTextForm"
          v-html="message"
        ></div>

        <div
          class="msg-item"
          v-else-if="!Array.isArray(message) && type == this.$ms.constant.MessageBoxType.confirmOnlyTextForm"
          v-text="message"
        ></div>
        <!-- confirm không hiện lại popup này lần sau -->
        <div
          class="mt-1 height-check-box"
          v-if="type == 7 || type == this.$ms.constant.MessageBoxType.confirmAutoGenerateParallel"
        >
          <ms-checkbox
            :label="customLabelCheckbox || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          ></ms-checkbox>
        </div>

        <div class="flex mt-1" v-if="type == 9">
          <ms-radio
            v-for="(item, index) in optionList"
            :key="index"
            :label="item.text"
            name="rdnameMessageBox"
            :keyValue="item.value"
            v-model="option"
            class="mb-2"
          />
          <div class="hr-row"></div>
          <ms-checkbox
            :label="customLabelCheckbox || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          ></ms-checkbox>
        </div>

        <div class="flex mt-1" v-if="type == 18">
          <ms-radio
            v-for="(item, index) in optionList"
            :key="index"
            :label="item.text"
            name="rdnameMessageBox"
            :keyValue="item.value"
            v-model="option"
            style="display: block"
            class="mb-2"
          />
        </div>

        <div class="flex mt-1" v-if="type == this.$ms.constant.MessageBoxType.confirmGenerateParallel">
          <span class="pointer text-link" @click="customCallback">(Xem chi tiết chênh lệch)</span>
        </div>
      </div>

      <!-- alert: info/warning -->
      <div
        class="msg-buttons flex-center"
        v-if="
          type == this.$ms.constant.MessageBoxType.confirm_Info_Warning ||
          type == this.$ms.constant.MessageBoxType.confirmOnlyTextForm
        "
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ textBtn || $t('i18nComponent.MessageBox.Accept') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="
          type == this.$ms.constant.MessageBoxType.confirm_Yes_No ||
          type == this.$ms.constant.MessageBoxType.confirmGenerateParallel
        "
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ textBtn || $t('i18nComponent.MessageBox.Yes') }}
        </button>

        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ customButton?.No || $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
      </div>
      <!-- confirm yes_no_cancel-->
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Yes_No_Cancel"
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
        <button @click="$close(this, null)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Cancel') }}
        </button>
      </div>
      <!-- xác nhận xem chi thiết thông tin người dùng -->
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="type == this.$ms.constant.MessageBoxType.view_user_info_detail"
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.ViewDetail') }}
        </button>
        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
      </div>
      <!-- Xác nhận lỗi khi in B02/BCTC -->
      <div class="msg-buttons flex-row revert-button" v-else-if="type == 400">
        <button
          @click="$close(this, true), $router.push('/summary/glprofitlosstransfer')"
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ textBtn }}
        </button>
        <button @click="$close(this, null)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Cancel') }}
        </button>
      </div>
      <!-- Xác nhận lỗi khi in C03/CCTT -->
      <div class="msg-buttons flex-center" v-else-if="type == 500">
        <button
          @click="$close(this, true), $router.push('/summary/crereplist')"
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ textBtn }}
        </button>
      </div>
      <!-- confirm yes_no_custom-->
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Yes_No_Custom"
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
      </div>
      <!-- confirm delete-->
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Delete"
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Delete') }}
        </button>

        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>

        <div class="flex"></div>
      </div>
      <!-- confirm Đóng -->
      <div class="msg-buttons flex-center" v-else-if="type == this.$ms.constant.MessageBoxType.confirm_Close">
        <button @click="$close(this, false)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div class="msg-buttons flex-row revert-button" v-else-if="type == 5 || type == 7">
        <button
          @click="
            $close(
              this,
              type == 7
                ? {
                    answer: true,
                    IsShowMessage: IsShowMessage,
                  }
                : true,
            )
          "
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ customButton.Yes }}
        </button>
        <button
          @click="
            $close(
              this,
              type == 7
                ? {
                    answer: false,
                    IsShowMessage: IsShowMessage,
                  }
                : false,
            )
          "
          class="msg-btn btn secondary-outline"
          :class="dbOptionHeight"
        >
          {{ customButton.No }}
        </button>
        <div class="flex"></div>
      </div>
      <!-- Hướng dẫn quyết toán nhanh -->
      <div class="msg-buttons flex-row revert-button" v-if="type == this.$ms.constant.MessageBoxType.quick_help_settlement">
        <button
          @click="
            $close(
              this,
              { answer: true}
            )
          "
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ customButton.Yes }}
        </button>
        <button
          @click="
            $close(
              this,
              { answer: false}
            )
          "
          class="msg-btn btn secondary-outline"
          :class="dbOptionHeight"
        >
          {{ customButton.No }}
        </button>
        <div class="flex"></div>
      </div>

      <div class="msg-buttons flex-center" v-if="type == 6">
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ textBtn }}
        </button>
      </div>

      <div class="msg-buttons flex-row revert-button" v-else-if="type == 8">
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">Xem phát sinh</button>
        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
        <div class="flex"></div>
      </div>

      <div class="msg-buttons flex-row revert-button" v-else-if="type == 9">
        <button
          @click="
            $close(this, {
              answer: true,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button
          @click="
            $close(this, {
              answer: false,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
          class="msg-btn btn secondary-outline"
          :class="dbOptionHeight"
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
      </div>

      <div class="msg-buttons flex-row revert-button" v-else-if="type == 18">
        <button
          @click="
            $close(this, {
              answer: true,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button
          @click="
            $close(this, {
              answer: false,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
          class="msg-btn btn secondary-outline"
          :class="dbOptionHeight"
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
      </div>

      <!-- Cảnh báo khi check chi tiết theo danh mục tài khoản -->
      <div class="msg-buttons flex-row revert-button" v-else-if="type == 11">
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
      </div>

      <!-- Xác nhận sinh hạch toán đồng thời-->
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirmAutoGenerateParallel"
      >
        <button
          @click="$close(this, {answer: true, IsShowMessage: IsShowMessage})"
          class="msg-btn btn primary"
          :class="dbOptionHeight"
        >
          {{ customButton.Yes }}
        </button>
        <button
          @click="$close(this, {answer: false, IsShowMessage: IsShowMessage})"
          class="msg-btn btn secondary-outline"
          :class="dbOptionHeight"
        >
          {{ customButton.No }}
        </button>
        <div class="flex"></div>
        <button @click="$close(this, null)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ customButton.Cancel }}
        </button>
      </div>
      <div
        class="msg-buttons flex-row revert-button"
        v-else-if="type == this.$ms.constant.MessageBoxType.confirmIncurredData"
      >
        <button @click="$close(this, true)" class="msg-btn btn primary" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.View') }}
        </button>
        <button @click="$close(this, false)" class="msg-btn btn secondary-outline" :class="dbOptionHeight">
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <div class="flex"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsMessageBox.scss';
.revert-button {
  flex-direction: row-reverse;
}
</style>
